import React from 'react';
import {
    Box,
    Button,
    Divider, Grid,
    IconButton, Paper,
    Typography
} from '@mui/material';
import Modal from "@mui/material/Modal";
import {Close} from "@mui/icons-material";

const BusinessProfileDeregisterDialog = ({
  open,
  onClose,
  onConfirm,
  peppolIdentifier,
  isPending = false,
}) => {
    return (
    <Modal open={open} onClose={onClose}>
        <Paper
            sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 700,
                p: 2,
                boxShadow: 24,
                outline: 'none',
            }}
        >
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h6">
                    {'Deregister business profile?'}
                </Typography>
                <IconButton onClick={onClose}>
                    <Close />
                </IconButton>
            </Box>
            <Divider />

            <Grid sx={{ pt: 1 }}>
                <Typography variant="body1" sx={{ py: 1 }}>
                    You are about to remove the profile <strong>{peppolIdentifier}</strong> from the Oman E-Invoicing Network. Once deregistered, this business will no longer be able to send or receive e-invoices and other electronic documents through Peppol.
                    <br/>
                    Are you sure you want to proceed?
                </Typography>
            </Grid>
            <Divider />
            <Grid mt={2} textAlign="right">
            <Button
                variant="contained"
                color="error"
                disabled={isPending}
                onClick={onConfirm}
            >
                {isPending ? 'Deregistering...' : 'Deregister'}
            </Button>
            </Grid>
        </Paper>
    </Modal>
  );
};

export default BusinessProfileDeregisterDialog;
